(function () {
  function resolveField(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    if (el.matches && el.matches('input, select, textarea')) return el;
    return el.querySelector('input, select, textarea');
  }

  function getValueFrom(selector) {
    var el = document.querySelector(selector);
    if (!el) return '';
    if (el.value !== undefined) return el.value;
    var field = resolveField(selector);
    if (field && field.value !== undefined) return field.value;
    return (el.textContent || '').trim();
  }

  function isEmiteFactura() {
    var el = document.querySelector('[name="emite_factura"]');
    if (!el) return false;
    if (el.type === 'checkbox') return el.checked;
    return el.value === '1' || el.value === 'true' || el.value === 'yes';
  }

  function parseNumber(val) {
    var str = String(val || '').trim().replace(/[€%\s]/g, '');
    if (!str) return 0;
    var normalized;
    if (str.indexOf(',') !== -1 && str.indexOf('.') !== -1) {
      normalized = str.replace(/\./g, '').replace(',', '.');
    } else if (str.indexOf(',') !== -1) {
      normalized = str.replace(',', '.');
    } else {
      normalized = str;
    }
    var n = parseFloat(normalized);
    return isNaN(n) ? 0 : n;
  }

  var _rawTotal = null;
  var _lastSetTotal = null;
  var _userSelectedMetodo = null;
  var _restoring = false;

  // IMPORTANTE: no usamos un listener general del form ni MutationObserver porque
  // imp_transferencia está DENTRO del form; los eventos que despachamos en él
  // volverían a disparar la función creando un bucle infinito.
  function syncImpTransferencia() {
    var currentTotal = getValueFrom('#total_enviado');

    // Si JFB ha actualizado el campo con un valor nuevo, capturarlo como total bruto
    if (currentTotal !== _lastSetTotal) {
      _rawTotal = currentTotal;
    }

    var sourceTotal = (_rawTotal !== null) ? _rawTotal : currentTotal;
    var totalValue = sourceTotal;

    if (isEmiteFactura()) {
      var totalNum = parseNumber(sourceTotal);
      var itpNum   = parseNumber(getValueFrom('#itp_enviado'));
      var adjusted = Math.round((totalNum - itpNum) * 100) / 100;
      totalValue   = String(adjusted).replace('.', ',');
    }

    _lastSetTotal = totalValue;

    var totalEnviadoField = resolveField('#total_enviado');
    if (totalEnviadoField && totalEnviadoField.value !== totalValue) {
      totalEnviadoField.value = totalValue;
    }

    // imp_transferencia es un campo oculto que Stripe/JFB leen para el cobro:
    // debe contener siempre el valor numérico bruto (punto decimal, sin formato).
    var rawImp = String(parseNumber(totalValue)).replace(',', '.');
    var impField = resolveField('[name="imp_transferencia"]');
    if (impField) {
      if (parseNumber(impField.value) !== parseNumber(totalValue)) {
        impField.value = rawImp;
        impField.dispatchEvent(new Event('input',  { bubbles: true }));
        impField.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        impField.value = rawImp;
      }
    }

    syncTotalStripe(totalValue);
  }

  // Lee el valor seleccionado en un Advanced Choice de JFB.
  // querySelector('[name="x"]') siempre devuelve el primer radio (primera opción),
  // no el seleccionado. Hay que buscar el que tiene :checked o el item con is-checked.
  function getCheckedChoiceValue(name) {
    var checked = document.querySelector('[name="' + name + '"]:checked');
    if (checked) return checked.value;
    var item = document.querySelector('.jet-form-builder-choice--item.is-checked [name="' + name + '"]');
    return item ? item.value : '';
  }

  // Calcula total_stripe directamente en JS para no depender de que JFB
  // recalcule su campo calculado (cuya caché interna puede quedar desfasada).
  // total_enviado nunca se modifica aquí; sólo se lee.
  // metodo puede pasarse directamente (desde el MutationObserver) o se detecta.
  function syncTotalStripe(totalValue, metodo) {
    if (metodo === undefined) {
      metodo = getCheckedChoiceValue('metodo_pago');
    }
    if (!metodo) return;
    var stripeValue = (metodo === 'transferencia_bancaria') ? '0' : totalValue;
    var field = resolveField('[name="total_stripe"]');
    if (field && field.value !== stripeValue) {
      field.value = stripeValue;
      field.dispatchEvent(new Event('input',  { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Cuando el usuario cambia metodo_pago, recalcula total_stripe con el
  // total ajustado actual (_lastSetTotal) sin alterar total_enviado.
  function triggerMetodoPagoRecalc(metodo) {
    var currentTotal = (_lastSetTotal !== null) ? _lastSetTotal : getValueFrom('#total_enviado');
    syncTotalStripe(currentTotal, metodo);
  }

  function bindMetodoPago() {
    var items = document.querySelectorAll('.jet-form-builder-choice--item');
    var found = false;
    items.forEach(function (item) {
      if (!item.querySelector('[name="metodo_pago"]')) return;
      if (item._metodoPagoBound) { found = true; return; }
      item._metodoPagoBound = true;
      found = true;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].attributeName === 'class' && item.classList.contains('is-checked')) {
            var input = item.querySelector('[name="metodo_pago"]');
            var metodo = input ? input.value : undefined;
            if (!_restoring) _userSelectedMetodo = metodo;
            triggerMetodoPagoRecalc(metodo);
            break;
          }
        }
      }).observe(item, { attributes: true });
    });
    return found;
  }

  function init() {
    var emiteEl = document.querySelector('[name="emite_factura"]');
    var impEl   = document.querySelector('[name="imp_transferencia"]');
    if (!emiteEl || !impEl) return false;
    if (emiteEl._impTransferBound) return true;
    emiteEl._impTransferBound = true;

    // Listener específico en emite_factura (no en el form completo para evitar bucle)
    emiteEl.addEventListener('change', syncImpTransferencia);

    // Red de seguridad periódica — cubre cambios de vehículo, precio, CCAA, etc.
    setInterval(syncImpTransferencia, 500);

    syncImpTransferencia();
    return true;
  }

  // Restaura la opción de metodo_pago elegida por el usuario después de un
  // re-render de JFB (que ocurre cuando total_enviado cambia y JFB recalcula
  // el calc_value de tarjeta_bancaria).
  function restoreMetodoPagoSelection() {
    if (!_userSelectedMetodo || _restoring) return;
    var items = document.querySelectorAll('.jet-form-builder-choice--item');
    var target = null;
    items.forEach(function (item) {
      var input = item.querySelector('[name="metodo_pago"]');
      if (input && input.value === _userSelectedMetodo && !item.classList.contains('is-checked')) {
        target = item;
      }
    });
    if (!target) return;
    _restoring = true;
    target.click();
    setTimeout(function () { _restoring = false; }, 200);
  }

  // Observa el contenedor de metodo_pago para detectar re-renders de JFB y
  // restaurar la selección del usuario. El observer sobre el contenedor
  // (no sobre el body completo) persiste indefinidamente para cubrir todos
  // los re-renders futuros.
  function waitForMetodoPago() {
    function attachContainerObserver() {
      var firstInput = document.querySelector('[name="metodo_pago"]');
      if (!firstInput) return false;
      var el = firstInput.parentElement;
      while (el && !el.classList.contains('jet-form-builder-choice--item')) {
        el = el.parentElement;
      }
      if (!el || !el.parentElement) return false;
      new MutationObserver(function () {
        bindMetodoPago();
        restoreMetodoPagoSelection();
      }).observe(el.parentElement, { childList: true });
      return true;
    }

    bindMetodoPago();
    if (attachContainerObserver()) return;

    var bodyObs = new MutationObserver(function () {
      if (bindMetodoPago() && attachContainerObserver()) {
        bodyObs.disconnect();
      }
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }

  function waitAndInit() {
    if (!init()) {
      var obs = new MutationObserver(function () {
        if (init()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
    waitForMetodoPago();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }
})();



// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-imp-transferencia.js